/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "m11.893 18.195.113.007a.9.9 0 0 0 .893-.787l.007-.113V8.909l2.418 2.41a.905.905 0 0 0 1.09.06l.096-.076a.899.899 0 0 0 .146-1.174l-.075-.096L12.716 6.1a.904.904 0 0 0-1.255-.087l-4.049 4.02a.898.898 0 0 0 .066 1.27.904.904 0 0 0 1.186.02l2.441-2.368v8.347a.9.9 0 0 0 .788.893Z"
})), "0 0 24 24", "ArrowUp");